import React, { useEffect, useState } from 'react';
import { API_URLS } from '../apiUrl';
import Pagination from '@mui/material/Pagination';
import axiosInstance from '../components/axiosInstance';

const AssignedHolding = ({ showModal, handleClose, surveyorId, municipalityId }: any) => {

    const [surveyData, setSurveyData] = useState<any>([]);
    const [searchTerm, setSearchTerm] = useState<string>(''); // State for the search term
    const [inputData, setInputData] = useState({ page: 1, limit: 50 });
    const [totalItems, setTotalItems] = useState(0);
    const [itemsPerPage] = useState(50);

    useEffect(() => {
        const fetchSurveyData = async () => {
            try {
                const response = await axiosInstance.post(API_URLS.FetchSurveyData, {
                    page: inputData.page,
                    limit: inputData.limit,
                    municipality_id: municipalityId,
                    surveyorId: surveyorId
                });

              
                setSurveyData(response.data.holding_info);
                setTotalItems(response.data.total_count);
            } catch (error) {
                console.error('Error fetching municipalities:', error);
            }
        };

        fetchSurveyData();
    }, [municipalityId, surveyorId, inputData.page]);

    // Filter the surveyData based on the searchTerm
    const filteredSurveyData = surveyData?.filter((row: any) => {
        return (
            row.holding_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.holding_type?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.name_of_complex_apartment?.toLowerCase().includes(searchTerm.toLowerCase())
        );
    });

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value);
    };


    const handlePageChange = (event: any, value: number) => {
        setInputData((prevData) => ({
            ...prevData,
            page: value,  // Update the current page
        }));
    };

    const totalPages = Math.ceil(totalItems / itemsPerPage);

    return (
        <div
            className={`fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50 ${showModal ? 'block' : 'hidden'}`}
            onClick={handleClose}
        >
            <div
                className="bg-white rounded-lg shadow-lg w-[700px]"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Modal Header */}
                <div className="flex gap-4 items-center p-4 border-b border-gray-200">
                    <h2 className="text-xl font-semibold">Survey Status</h2>

                    <div className="ms-auto flex items-center max-w-sm w-full">
                        <div className="relative w-full">
                            <input
                                type="text"
                                id="simple-search"
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                placeholder="Search..."
                                required
                                value={searchTerm}
                                onChange={handleSearchChange} // Update the searchTerm on change
                            />
                        </div>

                    </div>
                    <button className="text-gray-500" onClick={handleClose}><i className="ri-close-large-line"></i></button>
                </div>

                <div className='p-4 flex justify-start'>
                    <div className='flex gap-3'>
                        <div className='flex gap-1'><i className="ri-check-line text-green-500"></i><span>Completed</span></div>
                        <div>|</div>
                        <div className='flex gap-1'><i className="ri-close-large-line text-red-500"></i><span>Not Started</span></div>
                        <div>|</div>
                        <div className='flex gap-1'><i className="ri-hourglass-fill text-orange-500"></i><span>In Progress</span></div>
                    </div>
                </div>

                {/* Modal Body with Table */}
                <div className="p-4">
                    <div className='flex-grow overflow-auto max-h-72'>
                        <table className="min-w-full table-auto">
                            <thead className="border-b">
                                <tr>
                                    <th className="sticky top-0 py-2 px-4 text-left bg-white">Holding No</th>
                                    <th className="sticky top-0 py-2 px-4 text-left bg-white">Holding Type</th>
                                    <th className="sticky top-0 py-2 px-4 text-left bg-white">Name of Complex/Apartment</th>
                                    <th className="sticky top-0 py-2 px-4 text-left bg-white">Survey Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredSurveyData?.map((row: any, index: any) => (
                                    <tr key={index} className="border-b">
                                        <td className="py-2 px-4">{row.holding_no}</td>
                                        <td className="py-2 px-4">{row.holding_type == null ? "N/A" : row.holding_type}</td>
                                        <td className="py-2 px-4">{row.name_of_complex_apartment == null ? "N/A" : row.name_of_complex_apartment}</td>
                                        <td className="py-2 px-4">
                                            <button
                                                className={`mr-2 
                                                    ${row.is_survey_completed == 1 ? 'bg-green-500' :
                                                        row.is_survey_completed == 0 ? 'bg-red-500' :
                                                            row.is_survey_completed == 3 ? '' : ''} 
                                                    text-white py-1 px-3 rounded-full`}
                                            >
                                                {row.is_survey_completed == 1 ? '✔' :
                                                    row.is_survey_completed == 0 ? '✘' :
                                                        row.is_survey_completed == 3 ? '⏳' : ''}
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {/* Pagination */}
                    {filteredSurveyData?.length === 0 ? null :
                        <div className="flex justify-center mt-4">
                            {/* Pagination Component */}
                            <Pagination
                                count={totalPages}  // Set the total pages dynamically based on totalItems
                                page={inputData.page}
                                onChange={handlePageChange}
                                color="primary"
                            />
                        </div>}
                </div>

                {/* Modal Footer */}
                <div className="p-4 border-t border-gray-200">
                    <button
                        className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600"
                        onClick={handleClose}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AssignedHolding;

